import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_AddQwilrQueryBuilder = _resolveComponent("AddQwilrQueryBuilder")!
  const _component_QwilrDefinitionField = _resolveComponent("QwilrDefinitionField")!
  const _component_QwilrDefinitionBlock = _resolveComponent("QwilrDefinitionBlock")!
  const _component_QwilrDefinitionTemplate = _resolveComponent("QwilrDefinitionTemplate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, {
      PageTitle: 'Setup - ' + _ctx.qwilrDefinitionName
    }, null, 8, ["PageTitle"]),
    _createVNode(_component_AddQwilrQueryBuilder),
    _createVNode(_component_QwilrDefinitionField, {
      isKey: true,
      tableTitle: 'Key Fields'
    }),
    _createVNode(_component_QwilrDefinitionField, {
      isKey: false,
      tableTitle: 'Content Fields'
    }),
    _createVNode(_component_QwilrDefinitionBlock),
    _createVNode(_component_QwilrDefinitionTemplate),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToMainMenu && _ctx.goToMainMenu(...args))),
          class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 m-5 bg-primary",
          type: "button"
        }, " Back ")
      ])
    ])
  ], 64))
}